import base from "/home/ruri/github/monochrome/images/animate-spin.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");